import { ProjectsArray } from './ProjectGetResponse';

export const EmptyProjectDeleteItem: ProjectsArray = {
  id: 0,
  projectNumber: '',
  projectName: '',
  clientName: '',
  startDate: '',
  endDate: '',
  isUnproductive: false,
  isDairen: false,
};
